module.exports = __webpack_public_path__ + "img/brm3.7e5cae27.jpg";